'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _propTypes3 = require('../propTypes'),
    _withCommonProps = require('../withCommonProps'),
    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
    _themes = require('../themes'),
    _styles = require('../styles'),
    _Label = require('../Label'),
    _Label2 = _interopRequireDefault(_Label),
    _FormControlMessage = require('../FormControlMessage'),
    _FormControlMessage2 = _interopRequireDefault(_FormControlMessage);

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Styled = {};
Styled.div = {}, Styled.div.root = _styledComponents2.default.div.withConfig({
  displayName: 'FormGroup__root'
})(['', ';width:', ';max-width:100%;margin:0 0 20px 0;font-size:10px;vertical-align:top;'], function (props) {
  return props.sc.inheritStyles ? '' : (0, _styles.resetInheritedStyles)({
    direction: props.theme.vstui.i18n.direction
  });
}, function (_ref) {
  var sc = _ref.sc;
  return sc.fullWidth ? '100%' : '270px';
}), Styled.Label = (0, _styledComponents2.default)(_Label2.default).withConfig({
  displayName: 'FormGroup__Label'
})(['display:block;margin:0 0 7px 0;']), Styled.Label.displayName = 'Styled_Label', Styled.FormControlMessage = (0, _styledComponents2.default)(_FormControlMessage2.default).withConfig({
  displayName: 'FormGroup__FormControlMessage'
})(['margin:7px 0 0 0;']), Styled.FormControlMessage.displayName = 'Styled_FormControlMessage';

var FormGroup = function (_PureComponent) {
  function FormGroup() {
    return _classCallCheck(this, FormGroup), _possibleConstructorReturn(this, (FormGroup.__proto__ || Object.getPrototypeOf(FormGroup)).apply(this, arguments));
  }

  return _inherits(FormGroup, _PureComponent), _createClass(FormGroup, [{
    key: 'renderCheckboxControl',
    value: function renderCheckboxControl() {
      var _props = this.props,
          checkboxControl = _props.checkboxControl,
          disabled = _props.disabled,
          fullWidth = _props.fullWidth,
          id = _props.id,
          label = _props.label,
          labelHidden = _props.labelHidden,
          secondary = _props.secondary,
          size = _props.size,
          theme = _props.theme;
      return checkboxControl ? _react2.default.cloneElement(checkboxControl, {
        disabled: disabled,
        fullWidth: fullWidth,
        id: id,
        inheritStyles: !0,
        label: label,
        labelHidden: labelHidden,
        secondary: secondary,
        size: size,
        theme: theme
      }) : null;
    }
  }, {
    key: 'renderFormControl',
    value: function renderFormControl() {
      var conditionalProps = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
          _props2 = this.props,
          disabled = _props2.disabled,
          formControl = _props2.formControl,
          fullWidth = _props2.fullWidth,
          id = _props2.id,
          secondary = _props2.secondary,
          size = _props2.size,
          theme = _props2.theme;
      return formControl ? _react2.default.cloneElement(formControl, _extends({}, conditionalProps, {
        disabled: disabled,
        fullWidth: fullWidth,
        id: id,
        inheritStyles: !0,
        secondary: secondary,
        size: size,
        theme: theme
      })) : null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          commonProps = _props3.commonProps,
          disabled = _props3.disabled,
          fullWidth = _props3.fullWidth,
          helperText = _props3.helperText,
          id = _props3.id,
          inheritStyles = _props3.inheritStyles,
          label = _props3.label,
          labelHidden = _props3.labelHidden,
          rootProps = _props3.rootProps,
          secondary = _props3.secondary,
          size = _props3.size,
          theme = _props3.theme,
          validationMessage = _props3.validationMessage,
          formControlMessage = validationMessage || helperText,
          formControlMessageId = id + '-form-control-message',
          conditionalFormControlProps = {};
      formControlMessage && (conditionalFormControlProps['aria-describedby'] = formControlMessageId);
      var checkboxControl = this.renderCheckboxControl(),
          formControl = this.renderFormControl(conditionalFormControlProps);
      return _react2.default.createElement(Styled.div.root, _extends({}, commonProps, rootProps, {
        className: className,
        sc: {
          fullWidth: fullWidth,
          inheritStyles: inheritStyles
        },
        theme: theme
      }), formControl && label && _react2.default.createElement(Styled.Label, {
        disabled: disabled,
        htmlFor: id,
        inheritStyles: !0,
        secondary: secondary,
        size: size,
        theme: theme,
        visuallyHidden: labelHidden
      }, label), formControl || checkboxControl, formControlMessage && _react2.default.createElement(Styled.FormControlMessage, {
        disabled: disabled,
        error: !!validationMessage,
        id: formControlMessageId,
        inheritStyles: !0,
        secondary: secondary,
        size: size,
        theme: theme
      }, formControlMessage));
    }
  }]), FormGroup;
}(_react.PureComponent);

FormGroup.propTypes = {
  checkboxControl: _propTypes2.default.node,
  className: _propTypes2.default.string,
  commonProps: _propTypes3.commonPropsShape,
  disabled: _propTypes2.default.bool,
  formControl: _propTypes2.default.node,
  fullWidth: _propTypes2.default.bool,
  helperText: _propTypes2.default.string,
  id: _propTypes2.default.string,
  inheritStyles: _propTypes2.default.bool,
  label: _propTypes2.default.node,
  labelHidden: _propTypes2.default.bool,
  rootProps: _propTypes2.default.object,
  secondary: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  theme: _propTypes3.themeShape,
  validationMessage: _propTypes2.default.string
}, FormGroup.defaultProps = {
  theme: (0, _themes.createTheme)()
}, FormGroup.displayName = 'FormGroup';
var FormGroupWithTheme = (0, _withCommonProps2.default)(FormGroup);
FormGroupWithTheme.WrappedComponent = FormGroup, exports.default = FormGroupWithTheme;